// extracted by mini-css-extract-plugin
export default {"container":"zX-z","title":"AX-z","link":"BX-z"};